import React from 'react'
import type {
  Control,
  ControllerRenderProps,
  FieldPath,
  FieldValues
} from 'react-hook-form'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form'
import { cn } from '@/lib/utils'

export { Form } from '@/components/ui/form'

export interface IFormField {
  control: Control<any>
  name: string
  label?: string | React.ReactNode | undefined
  wrapperClassName?: string
  controlRender: ({
    field
  }: {
    field: ControllerRenderProps<FieldValues, FieldPath<FieldValues>>
  }) => React.ReactNode
}

export const FormValidField: React.FC<IFormField> = ({
  wrapperClassName,
  ...props
}) => {
  return (
    <FormField
      control={props.control}
      name={props.name}
      render={({ field }) => (
        <FormItem
          className={cn(
            'relative flex-1 space-y-0 xl:space-y-1',
            wrapperClassName
          )}
        >
          {props.label !== undefined && (
            <FormLabel className="block font-Orbitron text-sm text-color-text-secondary xl:text-xl">
              {props.label}
            </FormLabel>
          )}
          <FormControl>{props.controlRender({ field })}</FormControl>
          <FormMessage className="left-0 top-full xl:absolute" />
        </FormItem>
      )}
    ></FormField>
  )
}
